class CardsGridBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.container = this.block.querySelector('.cards-grid__container');
    this.cards = this.container.children;

    if (this.cards.length <= 2) {
      this.block.classList.add('cards-grid--x-wide');
    } else if (this.cards.length < 4) {
      this.block.classList.add('cards-grid--wide');
    }
  }
}

// Initialize each block on page load (front end)
if (!window.acf) {
  document.querySelectorAll('.cards-grid').forEach((block) => {
    new CardsGridBlock(block);
  });
}